import 'phaser'
import { createId } from '../main/common'
import { IFrameInfo } from '../main/frameInfo'
import { frameInfo } from '../main/frameInfo-sidecar'
import { layers } from '../main/layers-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'
import { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'

export interface IProgressIndicator extends IEntity {
  image: Phaser.GameObjects.Image
  percent: number
}

const objs: IProgressIndicator[] = []
export function findById(id: number) {
  return entitiesUtils.findById(id, objs)
}

let numPercentages = 10
const framesPercentage: IFrameInfo[] = []

for (let i = 0; i < numPercentages; i++) {
  framesPercentage.push(frameInfo.fi32(8, 20, 2 + i))
}

export function create(): IProgressIndicator {
  let id = createId()

  let image = spriteMap.createImageFromFrameInfo(
    layers.getLayers().indicators,
    framesPercentage[0],
    0,
    0,
    2,
  )

  let obj: IProgressIndicator = {
    eType: 'progress-indicator',
    id,
    image,
    isDead: false,
    percent: 0,
  }
  objs.push(obj)

  return obj
}

export function kill(obj: IProgressIndicator) {
  obj.isDead = true
  obj.image.tint = 0xccc
}

export function attach(
  obj: IProgressIndicator,
  x: number,
  y: number,
  percent: number,
) {
  obj.image.x = x
  obj.image.y = y

  let f = calcPercentFrame(numPercentages, percent)

  spriteMap.setFrame(obj.image, framesPercentage[f])

  // set percentage
}

export function calcPercentFrame(numFrames: number, val: number, max = 1) {
  let p = val / max
  let f = Math.round(numFrames * p)
  if (f >= numFrames) {
    f = numFrames - 1
  }
  if (f < 0) {
    f = 0
  }
  return f
}

export function updateAll() {
  objs.forEach((c) => {
    update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {
    c.image.destroy()
  })
}
function update(obj: IProgressIndicator) {}
